import isObject from 'lodash/isObject';
export var isCanceledPromise = function isCanceledPromise(error) {
  return isObject(error) && error.isCanceled === true;
};
export var createCancelablePromise = function createCancelablePromise(promise) {
  var hasCanceled = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(
    // eslint-disable-next-line prefer-promise-reject-errors
    function () {
      return hasCanceled ? reject({
        isCanceled: true
      }) : resolve.apply(void 0, arguments);
    },
    // eslint-disable-next-line prefer-promise-reject-errors
    function () {
      return hasCanceled ? reject({
        isCanceled: true
      }) : reject.apply(void 0, arguments);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled = true;
    }
  };
};